module.exports = __webpack_public_path__ + "img/YTO-background.4e63f266.png";